import { render, staticRenderFns } from "./TemplateLista.vue?vue&type=template&id=27e2eb9a&scoped=true&"
import script from "./TemplateLista.vue?vue&type=script&lang=js&"
export * from "./TemplateLista.vue?vue&type=script&lang=js&"
import style0 from "./TemplateLista.vue?vue&type=style&index=0&id=27e2eb9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e2eb9a",
  null
  
)

export default component.exports